<div class="col-md-12 mt-4 mb-4 aler_message_div position-relative" *ngIf="errors.length > 0">
    <div class="alert alert-custom alert-tansparant shadow-lg fade show pt-4 ps-4 pb-4 pe-4" role="alert" *ngFor="let error of errors">
        <div class="alert-custom-wrapper">
            <i class="far fa-times-circle alert-error warning-icon"></i>

            <strong class="warning-text">{{ error.message }}</strong>
        </div>
        <div class="alert-text alert-error"></div>
    </div>
</div>

<div class="col-md-12 mt-4 mb-4 aler_message_div position-relative" *ngIf="warnings.length > 0 && isWarningShown == true">
    <span class="alert_close" (click)="hideWarings()"><i class="fa fa-times" aria-hidden="true"></i></span>
    <div class="alert alert-custom alert-white shadow-lg fade show pt-4 ps-4 pb-4 pe-4" role="alert" *ngFor="let warning of warnings">
        <div class="alert-custom-wrapper">
            <i class="fa flaticon-warning alert-danger warning-icon"></i>
            <strong class="warning-text">{{ warning.message }}</strong>
        </div>
        <div class="alert-text alert-danger"></div>
    </div>
</div>

<div class="col-md-12 mt-4 mb-4" (click)="hideWarings()" *ngIf="warnings.length > 0 && isWarningShown == false">
    <div class="alert alert-custom alert-light-danger fade show mb-5" role="alert">
        <div class="alert-icon">
            <i class="flaticon-warning"></i>
        </div>
        <div class="alert-text">
            <i (click)="hideWarings()" class="alert-text" aria-hidden="true"> </i>
            <span style="font-size: 14px"
                ><strong> {{ warnings.length }} warnings available</strong></span
            >
        </div>
    </div>
</div>
<div class="col-md-12 mt-4 mb-4" *ngIf="notes.length > 0">
    <div class="alert alert-custom alert-notes shadow-lg fade show pt-4 ps-4 pb-4 pe-4" role="alert" *ngFor="let note of notes">
        <div class="alert-icon">
            <i class="fa fa-exclamation-circle" aria-hidden="true" style="margin-right: 6px"></i><strong>{{ note.message }}</strong>
        </div>
        <div class="alert-text"></div>
    </div>
</div>
